import { HpiEligibilityFlow } from 'src/shared/models/shared';
import { FlowLayoutSchema } from '../controllers/InsuranceController';
import { therapySchema } from '../pages/schema/extendedTherapySchema';
import { psychiatrySchema } from '../pages/schema/psychiatrySchema';

export enum RelationshipCodes {
    Self = '18',
}

export const addDashToZip = (val: string) => {
    let newVal = val.replace(/-/g, '');
    if (newVal.length > 5) newVal = `${newVal.slice(0, 5)}-${newVal.slice(5)}`;
    return newVal;
};

export const isPolicyHolder = (relationshipId: string) => relationshipId === RelationshipCodes.Self;

// BEWARE -- CHANGING THESE CHANGES ANALYTICS PAGE NAMES
export enum InsurancePageName {
    InsuranceApproved = 'insurance-approved',
    InsuranceIneligible = 'insurance-ineligible',
    InsuranceInactive = 'insurance-inactive',
    InsuranceError = 'insurance-error',
}

export const getSchema = (
    page: InsurancePageName,
    hpiEligibilityFlow: HpiEligibilityFlow,
    routedFromProfilePage: boolean,
    t,
    session?,
) => {
    let schema: FlowLayoutSchema;
    switch (hpiEligibilityFlow) {
        case HpiEligibilityFlow.Psychiatry:
            schema = psychiatrySchema(routedFromProfilePage, t, session)[page];
            break;
        case HpiEligibilityFlow.Therapy:
        default:
            schema = therapySchema(routedFromProfilePage, t, session)[page];
            break;
    }
    return schema;
};
